module.exports = __webpack_public_path__ + "static/media/jomo-ape-cover.cba2ba9a.png";